// auth.ts - Auth utility functions
import { browserLocalPersistence, setPersistence } from 'firebase/auth';
import { auth } from '../firebase';

/**
 * Initializes Firebase Auth listener and configures persistence
 */
export const initializeAuthListener = async () => {
  try {
    // Set persistence to LOCAL (persists even when browser is closed)
    await setPersistence(auth, browserLocalPersistence);

    // Add token refresh event listener
    auth.onIdTokenChanged(async (user) => {
      if (user) {
        // Refresh the token periodically to keep the session alive
        const tokenRefreshTime = 55 * 60 * 1000; // 55 minutes (tokens expire in 60 min)
        setInterval(async () => {
          const user = auth.currentUser;
          if (user) {
            try {
              await user.getIdToken(true);
            } catch (error) {
              console.error('Error refreshing token:', error);
            }
          }
        }, tokenRefreshTime);
      }
    });

    return true;
  } catch (error) {
    console.error('Error configuring auth persistence:', error);
    return false;
  }
};
